import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet (404) - Ecolaser ApS</title>
        <meta name="description" content="Siden du leder efter findes desværre ikke. Gå tilbage til forsiden for at læse om vores kemifrie laserrensning." />
        <html lang="da" />
      </Helmet>

      <section className="min-h-screen bg-dark-black flex items-center justify-center pt-24 pb-12 relative overflow-hidden">
        {/* Background Radial Gradient */}
        <div className="absolute inset-0 z-0 opacity-15">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(239,68,68,0.15),transparent_50%)]" />
        </div>

        <div className="relative z-10 max-w-xl mx-auto px-6 text-center flex flex-col items-center gap-6">
          <div className="w-20 h-20 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center text-red-500 text-4xl mb-2 animate-pulse">
            <i className="fa-solid fa-triangle-exclamation" />
          </div>
          
          <span className="text-red-500 text-xs font-bold uppercase tracking-widest font-mono">Fejl 404</span>
          
          <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight">
            Siden blev ikke fundet
          </h1>
          
          <p className="text-gray-400 text-sm md:text-base leading-relaxed">
            Siden du leder efter findes desværre ikke, eller er blevet flyttet. Du kan bruge menuen ovenfor eller klikke på knappen herunder for at gå tilbage til forsiden.
          </p>

          <div className="h-px w-12 bg-border-dark my-2" />

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <Link
              to="/"
              className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-light text-dark-black font-bold px-8 py-4 rounded-lg text-sm uppercase tracking-wider transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house" /> Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto bg-dark-gray hover:bg-dark-gray/80 text-white font-bold px-8 py-4 rounded-lg text-sm uppercase tracking-wider border border-border-dark transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-envelope" /> Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
